import {Component, Input} from '@angular/core';
import moment, {Moment} from 'moment';
import {customNgValueAccessor} from './control-value-accessor.component';
import {ResponsiveDatepickerComponent} from './responsive-datepicker.component';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-clearable-date-picker',
    templateUrl: './clearable-date-picker.component.html',
    providers: [
        customNgValueAccessor(ClearableDatePickerComponent)
    ]
})
export class ClearableDatePickerComponent extends ResponsiveDatepickerComponent {

    @Input()
    public label: string;

    @Input()
    public isRequired: boolean;

    @Input()
    public name: string;

    public currentFormControl: FormControl;

    @Input()
    public set formControl(newControl: FormControl){
      this.currentFormControl = newControl;
      this.currentFormControl.registerOnChange(this.onDateInputChanged.bind(this));
    }

    writeValue(value: any) {
        if (!value) {
            super.writeValue(null);
            return;
        }
        const date = moment(value);
        super.writeValue(date);
    }

    public onDateInputChanged(changedDate: Moment) {
        this.updateInternalModel(changedDate);
        if (!changedDate) {
            this.emitChangedValue(null);
            return;
        }
        this.emitChangedValue(changedDate);
    }

    public clear() {
        this.currentFormControl.setValue('');
    }

    public shouldShowClearButton(): boolean {
        return this.currentFormControl.value;
    }

    protected placeholderTextForInput() {
        return 'tt.mm.jjjj';
    }

}
